var _style, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_362",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 37.8",
    style: {
      enableBackground: "new 0 0 32 37.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D29B4D;}\n\t.st1{fill:#5F8A8B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_325",
    transform: "translate(9.323 15.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3971",
    className: "st0",
    d: "M2.9,12.7c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.2-0.6,0-0.8l9.2-9.2c0.2-0.2,0.6-0.2,0.8,0 c0.2,0.2,0.2,0.6,0,0.8l-9.2,9.2C3.3,12.7,3.1,12.7,2.9,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3972",
    className: "st0",
    d: "M0.6,10.4c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.2-0.6,0-0.8c0,0,0,0,0,0l9.2-9.2 c0.2-0.2,0.6-0.2,0.8,0c0,0,0,0,0,0c0.2,0.2,0.2,0.6,0,0.8L1,10.2C0.9,10.3,0.7,10.4,0.6,10.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3973",
    className: "st1",
    d: "M15.1,37.8L15.1,37.8c-0.6,0-1.1-0.2-1.5-0.6L0.6,24.3c-0.4-0.4-0.6-1-0.6-1.5 c0-0.8,0.4-1.6,0.9-2.1L13.8,7.7c0.9-0.8,2-1.2,3.2-1.3c0.1,0,7.4-0.6,11.5-0.5c0.2,0,0.3,0.1,0.4,0.2l2.9,2.9 C31.9,9.2,32,9.3,32,9.5c0.1,4-0.5,11.2-0.5,11.2c0,0,0,0.1,0,0.1c-0.1,0.3-0.1,0.5-0.2,0.7c-0.1,0.9-0.5,1.7-1.1,2.3l-12.9,13 C16.7,37.5,15.9,37.8,15.1,37.8z M27.5,7.1c-4.1,0-10.4,0.5-10.4,0.5c-0.9,0-1.8,0.4-2.4,1L1.8,21.5c-0.4,0.3-0.6,0.8-0.6,1.3 c0,0.3,0.1,0.5,0.3,0.7l12.9,12.9c0.2,0.2,0.4,0.3,0.7,0.3c0.5,0,1-0.2,1.3-0.6l12.9-13c0.4-0.5,0.7-1.1,0.8-1.7 c0.1-0.3,0.1-0.5,0.2-0.8c0.1-0.7,0.6-7.1,0.5-10.8l-2.6-2.6C28,7.1,27.7,7.1,27.5,7.1L27.5,7.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3974",
    className: "st0",
    d: "M20.8,4.6c-0.1-0.1-0.3-0.3-0.4-0.4c-3-3-7.1-5.3-8.7-3.6c-1.2,1.2-0.4,3.5,1.2,5.9 c0.3-0.2,0.6-0.5,0.9-0.6c-1.5-2.2-1.9-3.9-1.3-4.4c0.7-0.7,3.7,0.2,6.9,3.3c0.1,0.1,0.2,0.2,0.3,0.2c1.2,1.2,2.2,2.5,3,3.9 c0.4,0.6,0.6,1.3,0.8,2c-0.2,0.1-0.4,0.3-0.6,0.5c-0.3,0.3-0.5,0.6-0.6,0.9C22.1,12.7,22,13,22,13.4c0,0.7,0.3,1.3,0.8,1.8 c0.5,0.5,1.2,0.8,1.9,0.8c0.7,0,1.4-0.3,1.9-0.8c1.1-1.1,1.1-2.8,0-3.9c-0.6-0.6-1.4-0.9-2.2-0.8c-0.1-0.6-0.3-1.2-0.6-1.8 C23.1,7.3,22,5.8,20.8,4.6z M25.9,14.5c-0.3,0.3-0.7,0.5-1.2,0.5c-0.4,0-0.8-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.1 c0.3-0.1,0.7-0.2,0.9-0.5c0.3-0.3,0.5-0.7,0.5-1.2c0.5-0.1,1,0.1,1.3,0.5C26.5,12.8,26.5,13.8,25.9,14.5 C25.9,14.5,25.9,14.5,25.9,14.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.b768b4cd05900afe7ba3a33e08884ab7.svg";
export { ForwardRef as ReactComponent };